<template>
  <v-chip
    v-if="plan"
    size="x-small"
    variant="tonal"
    label
    :color="plan === 'included' ? 'success' : undefined"
    :prepend-icon="plan === 'included' ? 'mdi-check-circle-outline' : 'mdi-lock-outline'"
  >
    {{ t(`releasenotes.plan.${plan}`) }}
  </v-chip>
</template>

<script setup lang="ts">
/**
 * Whether a release highlight is in the reader's plan, on its card in the dialog and the changelog.
 *
 * Shown to everybody, not only to whoever can buy: an employee should be able to tell a feature they
 * already have from one somebody first has to add. Nothing when the plan is not known yet
 * (`presentRelease` answers null), rather than a guess either way.
 */
import { useI18n } from "vue-i18n"

defineProps<{ plan: "included" | "not_included" | null }>()

const { t } = useI18n()
</script>
